export interface ShellEnvironment {
  clientId: string;
  authorityUrl: string;
  cacheLocation: string;
  tokenScope: string;
  appInsightConnectionString: string;
  requiredAppRole: string;
  feedbackAppIdDev: string;
  feedbackAppIdProd: string;
  feedbackHostName: string;
  feedbackLocale: string;
}

const env = import.meta.env;

export const environment: ShellEnvironment = {
  clientId: env.VITE_CLIENT_ID ?? '',
  authorityUrl: env.VITE_AUTHORITY_URL ?? '',
  cacheLocation: env.VITE_CACHE_LOCATION ?? 'sessionStorage',
  tokenScope: env.VITE_TOKEN_SCOPE ?? '',
  appInsightConnectionString: env.VITE_APP_INSIGHT_CONNECTION_STRING ?? '',
  requiredAppRole: env.VITE_REQUIRED_APP_ROLE ?? 'ring0',
  feedbackAppIdDev: env.VITE_FEEDBACK_APP_ID_DEV ?? '50485',
  feedbackAppIdProd: env.VITE_FEEDBACK_APP_ID_PROD ?? '3056',
  feedbackHostName: env.VITE_FEEDBACK_HOST_NAME ?? 'OcvFeedbackDemoHostingApp',
  feedbackLocale: env.VITE_FEEDBACK_LOCALE ?? 'en',
};
